export default __webpack_public_path__ + "static/media/animation-dudes-principle.76bbfbae.gif";